__turbopack_context__.v({
  "storeNameButton": "SelectStoreMessage-module-scss-module__k8bE-a__storeNameButton",
});
